import { createContext, useContext } from 'react';

// to provide datadog logging to input components without needing a prop

export type LogFunction = ({
  message,
  payload,
  actionType,
}: {
  message: string;
  payload: object;
  actionType: 'Navigation' | 'Button' | 'Option' | 'Input';
}) => void;
const noOp: LogFunction = () => {};
export const LoggingContext = createContext<LogFunction>(noOp);

export function useDatadogLog(): LogFunction {
  return useContext(LoggingContext);
}
